import { customAlphabet } from "nanoid"

// Alphanumeric characters (uppercase + lowercase + digits)
const alphabet = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz"

export const generateRandomId = customAlphabet(alphabet, 20)
